import tw from "tailwind-styled-components";
import { NextImage } from "../../elements";

export const PathologiesWrapperMobile = tw.div`
  flex
  flex-col
  gap-8

  desktop:hidden
`;

export const PathologiesWrapperDesktop = tw.div`
  hidden

  desktop:flex
  desktop:flex-col
  desktop:gap-6
`;

export const MobileHeader = tw.div`
  flex
  flex-col
  gap-5
  px-6
`;

export const Title = tw.h3`
  text-lg
  font-bold

  desktop:text-3xl
  desktop:font-normal
  desktop:text-primary-800
`;

export const Description = tw.p`
  text-base

  desktop:pr-12
`;

export const ButtonWrapper = tw.div`
  flex
  flex-col
  items-center
`;

export const PathologiesItemsWrapper = tw.div`
  flex
  flex-row
  gap-5
  overflow-x-auto

  desktop:grid
  desktop:grid-cols-3
  desktop:gap-6
`;

export const DesktopHeader = tw.div`
  grid
  grid-cols-2
  gap-6
`;

export const DesktopModuleDescription = tw.div`
  flex
  flex-col
  gap-5
  p-6
  pb-12
  bg-gray-100
  rounded-2xl
`;

export const ClaimWrapper = tw.div`
  flex
  justify-center
  items-center
  px-24
  bg-secondary-100
  rounded-2xl
  text-3xl
  text-primary-800
  text-center
`;
